<template>
  <div class="wrapper fora" v-if="dadosExibicao">

    <!-- CABEÇALHO COM TÍTULO E BOTÕES DE AÇÃO NA MESMA ALTURA -->
    <div class="topo-header centro so-tela">
      <div class="titulo-esquerda">
        <botao-voltar class="voltar" nomeRota="Acompanhamentos" />
        <h1>Visualizar Movimentação</h1>
      </div>
      
      <!-- Botões de ação movidos para o lado direito do título -->
      <div class="acoes-topo" v-if="permissoes">
        <router-link v-if="permissoes.pode_editar" :to="{ name: 'AcompanhamentoEdit', params: { id: dadosExibicao.id } }">
          <button class="btn-acao btn-editar" title="Editar">Editar</button>
        </router-link>
        <button v-if="permissoes.pode_deletar" class="btn-acao btn-excluir" title="Excluir" @click.prevent="modalExclusaoVisivel = true">Excluir</button>
      </div>
    </div>

    <div class="form centro">      
      <div class="container-abas-topo so-tela">
        <nav class="abas">
          <button
            type="button"
            class="aba"
            :class="{ ativa: abaAtiva === 'dados_basicos' }"
            @click="abaAtiva = 'dados_basicos'"
          >
            Dados Básicos
          </button>
          <button
            type="button"
            class="aba"
            :class="{ ativa: abaAtiva === 'monitoramento' }"
            @click="abaAtiva = 'monitoramento'"
          >
            Monitoramento de Datas
          </button>
          <button
            type="button"
            class="aba"
            :class="{ ativa: abaAtiva === 'status_sei' }"
            @click="abaAtiva = 'status_sei'"
          >
            Status SEI
          </button>
        </nav>
        
        <!-- Bloco .acoes-topo foi removido daqui para subir para o cabeçalho -->
      </div>               
        

      <div class="conteudo-abas">
        
        <!-- ABA 1: DADOS BÁSICOS -->
        <div class="painel-dados" v-show="abaAtiva === 'dados_basicos'">
          <div class="secao-dados">
            <h2 class="secao-titulo">Informações Gerais</h2>
            <div class="grade-dados">
              
              <!-- LINHA 1: PROCESSO (1 coluna) | ÓRGÃO (3 colunas) | TIPO (2 colunas) = 6 Colunas -->
              <div class="item-dado">
                <span class="item-rotulo">Processo SEI</span>
                <span class="item-valor">{{ dadosExibicao.processo_sei || '-' }}</span>                    
              </div>
              <div class="item-dado item-dado--span3">
                <span class="item-rotulo">Órgão</span>
                <span class="item-valor">{{ formatarNomeProprio(dadosExibicao.colegiado_nome) || '-' }}</span>                    
              </div>
              <div class="item-dado item-dado--span2">
                <span class="item-rotulo">Tipo de Movimentação</span>
                <span class="item-valor texto-capitalizado">{{ formatarTipoMovimentacao(dadosExibicao.tipo_movimentacao) }}</span>
              </div>

              <!--  LINHAS CONDICIONAIS DEPENDENDO DO TIPO DE MOVIMENTAÇÃO -->

              <!-- CASO A: Indicação ou Recondução -->
              <template v-if="['indicacao', 'reconducao'].includes(dadosExibicao.tipo_movimentacao)">
                <div class="item-dado item-dado--span2">
                  <span class="item-rotulo">Conselho</span>
                  <span class="item-valor">{{ formatarNomeProprio(dadosExibicao.conselho_indicado_nome) || '-' }}</span>
                </div>
                <div class="item-dado">
                  <span class="item-rotulo">Cargo</span>
                  <span class="item-valor">{{ formatarNomeProprio(dadosExibicao.cargo_indicado_nome) || '-' }}</span>
                </div>
                <div class="item-dado item-dado--span2">
                  <span class="item-rotulo">Nome Indicado</span>
                  <span class="item-valor">{{ formatarNomeProprio(dadosExibicao.nome_indicado) || '-' }}</span>
                </div>
                <div class="item-dado">
                  <span class="item-rotulo">CPF Indicado</span>
                  <span class="item-valor">{{ formatarCPF(dadosExibicao.cpf_indicado) || '-' }}</span>
                </div>
              </template>

              <!-- CASO B: Destituição ou Exoneração (Apenas 1 linha de pessoas) -->
              <template v-else-if="['destituicao', 'exoneracao'].includes(dadosExibicao.tipo_movimentacao)">
                <div class="item-dado item-dado--span2">
                  <span class="item-rotulo">Conselho</span>
                  <span class="item-valor">{{ formatarNomeProprio(dadosExibicao.conselho_destituido_nome) || '-' }}</span>
                </div>
                <div class="item-dado">
                  <span class="item-rotulo">Cargo</span>
                  <span class="item-valor">{{ formatarNomeProprio(dadosExibicao.cargo_destituido_nome) || '-' }}</span>
                </div>
                <div class="item-dado item-dado--span2">
                  <span class="item-rotulo">{{ labelNomeSaida }}</span>
                  <span class="item-valor">{{ formatarNomeProprio(dadosExibicao.nome_destituido) || '-' }}</span>
                </div>
                <div class="item-dado">
                  <span class="item-rotulo">{{ labelCpfSaida }}</span>
                  <span class="item-valor">{{ formatarCPF(dadosExibicao.cpf_destituido) || '-' }}</span>
                </div>
              </template>

              <!-- CASO C: Substituição (Duas linhas de pessoas) -->
              <template v-else-if="dadosExibicao.tipo_movimentacao === 'substituicao'">
                <!-- Linha do Indicado -->
                <div class="item-dado item-dado--span2">
                  <span class="item-rotulo">Conselho Indicado</span>
                  <span class="item-valor">{{ formatarNomeProprio(dadosExibicao.conselho_indicado_nome) || '-' }}</span>
                </div>
                <div class="item-dado">
                  <span class="item-rotulo">Cargo Indicado</span>
                  <span class="item-valor">{{ formatarNomeProprio(dadosExibicao.cargo_indicado_nome) || '-' }}</span>
                </div>
                <div class="item-dado item-dado--span2">
                  <span class="item-rotulo">Nome Indicado</span>
                  <span class="item-valor">{{ formatarNomeProprio(dadosExibicao.nome_indicado) || '-' }}</span>
                </div>
                <div class="item-dado">
                  <span class="item-rotulo">CPF Indicado</span>
                  <span class="item-valor">{{ formatarCPF(dadosExibicao.cpf_indicado) || '-' }}</span>
                </div>

                <!-- Linha do Substituído -->
                <div class="item-dado item-dado--span2">
                  <span class="item-rotulo">Conselho Substituído</span>
                  <span class="item-valor">{{ formatarNomeProprio(dadosExibicao.conselho_destituido_nome) || '-' }}</span>
                </div>
                <div class="item-dado">
                  <span class="item-rotulo">Cargo Substituído</span>
                  <span class="item-valor">{{ formatarNomeProprio(dadosExibicao.cargo_destituido_nome) || '-' }}</span>
                </div>
                <div class="item-dado item-dado--span2">
                  <span class="item-rotulo">{{ labelNomeSaida }}</span>
                  <span class="item-valor">{{ formatarNomeProprio(dadosExibicao.nome_destituido) || '-' }}</span>
                </div>
                <div class="item-dado">
                  <span class="item-rotulo">{{ labelCpfSaida }}</span>
                  <span class="item-valor">{{ formatarCPF(dadosExibicao.cpf_destituido) || '-' }}</span>
                </div>
              </template>

              <!-- CASO D: Outros Tipos (Fallback de segurança) -->
              <template v-else>
                <div class="item-dado item-dado--span2">
                  <span class="item-rotulo">Conselho</span>
                  <span class="item-valor">-</span>
                </div>
                <div class="item-dado">
                  <span class="item-rotulo">Cargo</span>
                  <span class="item-valor">-</span>
                </div>
                <div class="item-dado item-dado--span2">
                  <span class="item-rotulo">Nome Envolvido</span>
                  <span class="item-valor">-</span>
                  <div class="flexbox">
                <div class="item status-acompanhamento">
                  <!-- <label><b>Status:</b></label> -->
                  <p :class="dadosExibicao.concluido === true ? 'status-concluido' : 'status-andamento'">
                    {{ dadosExibicao.concluido === true ? 'Concluído' : 'Em Andamento' }}
                  </p>
                </div>
              </div>

            </div>
                <div class="item-dado">
                  <span class="item-rotulo">CPF Envolvido</span>
                  <span class="item-valor">-</span>
                </div>
              </template>
              
              <div class="item-dado item-dado--largo" v-if="dadosExibicao.obs_acompanhamento">
                <span class="item-rotulo">Observação</span>
                <span class="item-valor">{{ dadosExibicao.obs_acompanhamento }}</span>                    
              </div>
            </div>
          </div>
        </div>

        <!-- ABA 2: DATAS -->
        <div class="painel-dados" v-show="abaAtiva === 'monitoramento'">       
          <div class="secao-dados">
            <h2 class="secao-titulo">Histórico de Movimentação</h2>
            <div class="grade-dados">
              
              <!-- Linha 1: Sempre aparece (cada um ocupa 2 colunas = 3 itens na linha) -->
              <div class="item-dado item-dado--span2">
                <span class="item-rotulo">Chegada da Demanda</span>
                <span class="item-valor">{{ formatarData((dadosExibicao.acompanhamento_data || {}).chegada_da_demanda) }}</span>
              </div>
              <div class="item-dado item-dado--span2">
                <span class="item-rotulo">Envio p/ Assinatura</span>
                <span class="item-valor">{{ formatarData((dadosExibicao.acompanhamento_data || {}).envio_para_assinatura) }}</span>
              </div>
              <div class="item-dado item-dado--span2">
                <span class="item-rotulo">Assinatura</span>
                <span class="item-valor">{{ formatarData((dadosExibicao.acompanhamento_data || {}).data_da_assinatura) }}</span>
              </div>
              
              <!-- Linha 2: Some na Exoneração -->
              <div class="item-dado item-dado--span2" v-if="dadosExibicao.tipo_movimentacao !== 'exoneracao'">
                <span class="item-rotulo">Envio DIEEG</span>
                <span class="item-valor">{{ formatarData((dadosExibicao.acompanhamento_data || {}).envio_para_dieeg) }}</span>
              </div>
              <div class="item-dado item-dado--span2" v-if="dadosExibicao.tipo_movimentacao !== 'exoneracao'">
                <span class="item-rotulo">Envio p/ Validação</span>
                <span class="item-valor">{{ formatarData((dadosExibicao.acompanhamento_data || {}).envio_para_validacao) }}</span>
              </div>
              <div class="item-dado item-dado--span2" v-if="dadosExibicao.tipo_movimentacao !== 'exoneracao'">
                <span class="item-rotulo">Encaminhamento à Entidade</span>
                <span class="item-valor">{{ formatarData((dadosExibicao.acompanhamento_data || {}).encaminhamento_entidade) }}</span>
              </div>                

              <!-- Linha 3: Some parcialmente na Exoneração -->
              <div class="item-dado item-dado--span2">
                <span class="item-rotulo">Retorno Validação</span>
                <span class="item-valor">{{ formatarData((dadosExibicao.acompanhamento_data || {}).retorno_validacao) }}</span>
              </div>                
              <div class="item-dado item-dado--span2" v-if="dadosExibicao.tipo_movimentacao !== 'exoneracao'">
                <span class="item-rotulo">Assembleia</span>
                <span class="item-valor">{{ formatarData((dadosExibicao.acompanhamento_data || {}).data_assembleia) }}</span>
              </div>
              <div class="item-dado item-dado--span2">
                <span class="item-rotulo">Data de Publicação (DOE)</span>
                <span class="item-valor">{{ formatarData((dadosExibicao.acompanhamento_data || {}).data_publicacao) }}</span>
              </div>

              <!-- Linha 4: Some completamente na Exoneração -->
              <div class="item-dado item-dado--span2" v-if="dadosExibicao.tipo_movimentacao !== 'exoneracao'">
                <span class="item-rotulo">Início do Mandato (Posse)</span>
                <span class="item-valor">{{ formatarData((dadosExibicao.acompanhamento_data || {}).inicio_mandato) }}</span>
              </div>
              <div class="item-dado item-dado--span2" v-if="dadosExibicao.tipo_movimentacao !== 'exoneracao'">
                <span class="item-rotulo">Fim do Mandato</span>
                <span class="item-valor">{{ formatarData((dadosExibicao.acompanhamento_data || {}).fim_mandato) }}</span>
              </div>

            </div>
          </div>
        </div>

        <!-- ABA 3: STATUS SEI -->
        <div class="painel-dados" v-show="abaAtiva === 'status_sei'">
          <fieldset>
            <div class="caixa-form item">
              <div class="flexbox">
                <div class="item">
                  <label><b>Processo SEI Vinculado:</b></label>
                  <p v-if="!idProcedimento">{{ dadosExibicao.processo_sei || 'Nenhum processo informado' }}</p>
                  <a v-else :href="retornarLinkAcesso(dadosExibicao.processo_sei_link_base)" target="_blank" class="link-sei-tabela">
                    {{ dadosExibicao.processo_sei }} <small>(Abrir no SEI)</small>
                  </a>
                </div>
              </div>
             
              <div v-if="carregandoSei" class="alerta-sei alerta-info">
                Buscando histórico de andamentos no servidor do SEI...
              </div>
              <div v-else-if="erroSei" class="alerta-sei alerta-erro">
                Não foi possível carregar os andamentos do SEI. Verifique se o número do processo está correto.
              </div>

              <!-- Tabela de Andamentos -->
              <div v-else style="margin-top: 1.5rem;">
                <table class="tabela-andamentos-sei">
                  <thead>
                    <tr>
                      <th style="width: 20%;">Data/Hora</th>
                      <th style="width: 15%;">Unidade</th>
                      <th style="width: 15%;">Usuário</th>
                      <th style="width: 50%;">Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="andamento in andamentosPaginados" :key="andamento.id_andamento">
                      <td>{{ andamento.data_hora }}</td>
                      <td>{{ andamento.unidade ? andamento.unidade.sigla : '-' }}</td>
                      <td>{{ andamento.usuario ? andamento.usuario.sigla : '-' }}</td>
                      <td v-html="formatarDescricao(andamento.descricao)"></td>
                    </tr>
                    <tr v-if="andamentosSei.length === 0">
                      <td colspan="4" class="texto-centro">Nenhum andamento encontrado neste processo.</td>
                    </tr>
                  </tbody>
                </table>

                <!-- Paginação -->
                <div class="paginacao-wrapper" v-if="totalPaginas > 1">
                  <paginate
                    :page-count="totalPaginas"
                    :click-handler="paginarAndamentos"
                    :prev-text="'Anterior'"
                    :next-text="'Próximo'"
                    :container-class="'pagination-sei'"
                    :page-class="'page-item'"
                    :prev-class="'page-item'"
                    :next-class="'page-item'"
                    :disabled-class="'disabled'"
                    :active-class="'active-page'">
                  </paginate>
                </div>
              </div>
            </div>
          </fieldset>
        </div>

      </div>
    </div>

    <!-- ================== MODAL DE EXCLUSÃO ================== -->
    <div v-if="modalExclusaoVisivel" class="modal-exclusao">
      <div class="modal-mask">
        <div class="modal-container">
          <div class="modal-header">
            <h2>Deseja mesmo excluir esta Movimentação?</h2>
          </div>
          <div class="modal-body">
            <p>Dados Básicos da Movimentação:</p>
            <div class="dados">
              
              <div class="flexbox">
                <div class="texto-centralizado">
                  Processo SEI: <span>{{ dadosExibicao.processo_sei || '-' }}</span>
                </div>
                <div class="texto-centralizado">
                  Órgão: <span>{{ formatarNomeProprio(dadosExibicao.colegiado_nome) || '-' }}</span>
                </div>
                <div class="texto-centralizado">
                  Tipo: <span class="texto-capitalizado">{{ formatarTipoMovimentacao(dadosExibicao.tipo_movimentacao) }}</span>
                </div>
              </div>
              
              <div class="flexbox" v-if="['indicacao', 'reconducao', 'substituicao'].includes(dadosExibicao.tipo_movimentacao)">
                <div class="texto-centralizado">
                  Nome Indicado: <span>{{ formatarNomeProprio(dadosExibicao.nome_indicado) || '-' }}</span>
                </div>
                <div class="texto-centralizado">
                  CPF Indicado: <span>{{ formatarCPF(dadosExibicao.cpf_indicado) || '-' }}</span>
                </div>
              </div>
              
              <div class="flexbox" v-if="['destituicao', 'exoneracao', 'substituicao'].includes(dadosExibicao.tipo_movimentacao)">
                <div class="texto-centralizado">
                  {{ labelNomeSaida }}: <span>{{ formatarNomeProprio(dadosExibicao.nome_destituido) || '-' }}</span>
                </div>
                <div class="texto-centralizado">
                  {{ labelCpfSaida }}: <span>{{ formatarCPF(dadosExibicao.cpf_destituido) || '-' }}</span>
                </div>
              </div>

            </div>
          </div>
          <div class="modal-footer">
            <button class="btn-confirmar-exclusao" @click="confirmarExclusao">Sim</button>
            <button class="btn-cancelar-exclusao" @click="modalExclusaoVisivel = false">Não</button>
          </div>
        </div>
      </div>
    </div>
    <!-- ======================================================= -->

    <div>
      <Footer
        :createdByLabel="'Criado por'"
        :criadoPor="dadosExibicao.criado_por"
        :lastUpdatedByLabel="'Última atualização feita por'"
        :atualizadoPor="dadosExibicao.atualizado_por"
        :emLabel="' em '"
        :SistemaLabel="'Sistema'"
        :created_at="dadosExibicao.created_at || '2026-06-01T10:00:00Z'"
        :updated_at="dadosExibicao.updated_at || '2026-06-05T15:30:00Z'"
      />
    </div>
  </div>
</template>

<script>
  import BotaoVoltar from "../BotaoVoltar.vue";
  import { parseISO, format, isValid } from "date-fns";
  import Footer from "../Footer.vue";
  import AcompanhamentoApi from "../../services/AcompanhamentoApi.js";
  import Paginate from "vuejs-paginate";

  export default {
    name: "ExibirAcompanhamento",
    props: {
      acompanhamento: Object,
      permissoes: {
        type: Object,
        default: () => ({ pode_editar: true, pode_deletar: true })
      },
    },
    data() {
      return {
        abaAtiva: 'dados_basicos', // Controle das guias
        dadosExibicao: null,
        modalExclusaoVisivel: false, // Controle de visibilidade do Modal
        
        // Dados Exclusivos da Nova Aba SEI
        acompanhamentoApi: null,
        carregandoSei: false,
        erroSei: false,
        andamentosSei: [],
        idProcedimento: null,
        paginaAtual: 1,
        resultadosPorPagina: 5,
        dadosAcompanhamentos: {
          criado_por: null,
          atualizado_por: null,
          created_at: null,
          updated_at: null,
      },
      };
    },
    created() {
      // Recebe os dados reais se eles existirem
      if (this.acompanhamento && Object.keys(this.acompanhamento).length > 0) {
        this.dadosExibicao = this.acompanhamento;
      } else {
        // Se não vier nada, deixa vazio
        this.dadosExibicao = {}; 
      }
      // Inicia as chamadas ao SEI ao montar o componente
      this.acompanhamentoApi = new AcompanhamentoApi();
      
      // Só faz a busca no SEI se realmente existir um processo
      if (this.dadosExibicao && this.dadosExibicao.processo_sei) {
        this.consultarProcedimentoSei();
        this.consultarAndamentosSei();
      }
    },
    computed: {
      labelNomeSaida() {
        if (!this.dadosExibicao) return 'Nome Destituído:';
        if (this.dadosExibicao.tipo_movimentacao === 'substituicao') return 'Nome Substituído:';
        if (this.dadosExibicao.tipo_movimentacao === 'exoneracao') return 'Nome Exonerado:';
        return 'Nome Destituído:';
      },
      labelCpfSaida() {
        if (!this.dadosExibicao) return 'CPF Destituído:';
        if (this.dadosExibicao.tipo_movimentacao === 'substituicao') return 'CPF Substituído:';
        if (this.dadosExibicao.tipo_movimentacao === 'exoneracao') return 'CPF Exonerado:';
        return 'CPF Destituído:';
      },
      // Computed Properties para a Paginação do SEI
      totalPaginas() {
        return Math.ceil(this.andamentosSei.length / this.resultadosPorPagina);
      },
      andamentosPaginados() {
        const inicio = (this.paginaAtual - 1) * this.resultadosPorPagina;
        const fim = inicio + this.resultadosPorPagina;
        return this.andamentosSei.slice(inicio, fim);
      }
    },
    components: {
      BotaoVoltar,
      Footer,
      Paginate,
    },
    methods: {
      async confirmarExclusao() {
        try {
          if (!this.acompanhamentoApi) this.acompanhamentoApi = new AcompanhamentoApi();
          if (this.acompanhamentoApi.cancelTokens && this.acompanhamentoApi.cancelTokens.destroyAcompanhamento) {
            this.acompanhamentoApi.cancelTokens.destroyAcompanhamento.cancel();
          }

          await this.acompanhamentoApi.destroyAcompanhamento(this.dadosExibicao.id);
          this.$router.push({ name: "Acompanhamentos" }); // Redireciona o usuário para a listagem
        } catch (err) {
          if (this.acompanhamentoApi.isCancel && this.acompanhamentoApi.isCancel(err)) return;
          
          this.modalExclusaoVisivel = false;
          alert("Não foi possível excluir esta movimentação. Verifique os vínculos pendentes.");
        }
      },
      formatarNomeProprio(texto) {
        if (!texto) return '';
        
        const excecoesMinusculas = ['de', 'da', 'do', 'das', 'dos', 'e'];
        const siglasConhecidas = [
          'AGR', 'ALEGO', 'SANEAGO', 'DETRAN', 'SGU', 'SISCOL', 'GOINFRA', 
          'CPF', 'RG', 'GO', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'
        ];
        
        return texto
          .toString()
          .toLowerCase()
          .split(' ')
          .map(palavra => {
            const palavraLimpa = palavra.replace(/[()]/g, '').toUpperCase();
  
            if (siglasConhecidas.includes(palavraLimpa)) {
              return palavra.toUpperCase();
            }
  
            if (excecoesMinusculas.includes(palavra)) {
              return palavra;
            }
  
            return palavra.charAt(0).toUpperCase() + palavra.slice(1);
          })
          .join(' ');
      },
      formatarTipoMovimentacao(valor) {
        if (!valor) return '-';
        if (valor.toLowerCase() === 'indicacao') return 'Indicação';
        if (valor.toLowerCase() === 'destituicao') return 'Destituição';
        if (valor.toLowerCase() === 'substituicao') return 'Substituição';
        if (valor.toLowerCase() === 'exoneracao') return 'Exoneração';
        if (valor.toLowerCase() === 'reconducao') return 'Recondução';
        return valor; 
      },
      formatarCPF(cpf) {
        if (!cpf) return null;
        let cpfLimpo = cpf.toString().replace(/\D/g, '');
        if(cpfLimpo.length === 11) {
          return cpfLimpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        return cpf;
      },
      formatarData(value) {
        if (value == null || value === '') {
          return '-';
        }
        if (value.includes('/')) return value;
        try {
          const dataParseada = parseISO(value);
          if (isValid(dataParseada)) {
            return format(dataParseada, "dd/MM/yyyy");
          }
          return value;
        } catch (e) {
          return value; 
        }
      },
      
      // -- MÉTODOS EXCLUSIVOS DA ABA SEI --
      retornarLinkAcesso(urlBaseSei) {
        if (!urlBaseSei) urlBaseSei = "https://sei.go.gov.br/sei/controlador.php?acao=procedimento_trabalhar&id_procedimento=";
        return urlBaseSei + this.idProcedimento;
      },
      async consultarProcedimentoSei() {
        try {
          const numeroProcessoSei = this.dadosExibicao.processo_sei;
          const procedimentoSei = await this.acompanhamentoApi.getProcedimentoSei(numeroProcessoSei);
          let id_procedimento = procedimentoSei?.consultar_procedimento_response?.parametros?.id_procedimento;
          if (id_procedimento) this.idProcedimento = id_procedimento;
        } catch (err) {
          console.warn("Erro ao buscar link do SEI.", err);
        }
      },
      async consultarAndamentosSei() {
        try {
          this.carregandoSei = true;
          this.erroSei = false;
          this.andamentosSei = [];

          const numeroProcessoSei = this.dadosExibicao.processo_sei;
          const dadosAndamentosSei = await this.acompanhamentoApi.getAndamentosSei(numeroProcessoSei);
          
          let itens = dadosAndamentosSei?.listar_andamentos_response?.parametros?.item;
          
          if (itens) {
            let arrayAndamentos = Array.isArray(itens) ? itens : [itens];
            arrayAndamentos.forEach(andamento => this.andamentosSei.push(andamento));
          }
        } catch (err) {
          console.error("Erro ao consultar andamentos.", err);
          this.erroSei = true;
        } finally {
          this.carregandoSei = false;
        }
      },
      formatarDescricao(descricao) {
        if (!descricao) return '-';
        let stringOriginal = descricao;
        if (stringOriginal.includes("<a")) {
          let elementoTemporario = document.createElement("div");
          elementoTemporario.innerHTML = stringOriginal;
          let tagA = elementoTemporario.querySelector("a");
          if(tagA) {
            let textoDentroDaTag = tagA.textContent;
            return stringOriginal.replace(/<a.*?>(.*?)<\/a>/, textoDentroDaTag);
          }
        }
        return stringOriginal;
      },
      paginarAndamentos(numeroPagina) {
        this.paginaAtual = numeroPagina;
      }
    },
  };
</script>

<style lang="scss" scoped>    
* {
  margin: 0;
  padding: 0;
  font-family: 'Karla', sans-serif;
}

.item { margin: .3rem 0; }
.texto-capitalizado { text-transform: capitalize; }

/* ESTRUTURA GLOBAL */
.fora, 
.wrapper, 
.form, 
.form.centro, 
.topo-header {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

.fora {
  width: 100% !important; 
  max-width: 100% !important;  
  padding: 1.5rem 0 !important; 
  margin: 0 !important; 
  min-height: calc(100vh - 10rem);
}
    .item {
        margin: .3rem 0
    }

    .texto-capitalizado {
      text-transform: capitalize;
    }

    .status-acompanhamento p {
      width: fit-content;
      border-radius: 0.25rem;
      font-family: "Montserrat-Medium";
      padding: 0.25rem 0.6rem;
    }

    .status-concluido {
      background-color: #d4edda;
      color: #155724;
    }

    .status-andamento {
      background-color: #fff3cd;
      color: #856404;
    }
    

    @media screen and (min-width: "1066px") {
        .tab-conteudo {
            height: fit-content;
            display: inline;
            .centro {
                max-width: 100%;
            }
        }
    }

.wrapper {
  padding: 1.2rem 0 !important;
  margin: 0 auto !important;
  border: none !important;
}

/* 3. LARGURA EXATA DO COLEGIADOS */
.form.centro,
.centro {
  width: 96vw !important;
  max-width: 96vw !important;
  margin: 0 auto !important;
  padding: 0 !important;
}

/* Título */
/* Título e Ações Alinhados */
.topo-header {
  margin: 0 0 1.2rem 0; // Aumentado um pouco a margem inferior para dar um respiro pras abas
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between; // Joga o título para a esquerda e as ações para a direita

  .titulo-esquerda {
    display: flex;
    align-items: center;

    h1 {
      margin-left: 0.75rem;
      font-family: "Montserrat-Medium";
      font-weight: bold; 
      color: #ffa600;
      font-size: 1.8rem;
    }
  }

  // Estilização das ações quando posicionadas no cabeçalho
  .acoes-topo {
    display: flex;
    gap: 0.5rem;
    align-items: center;

    .btn-acao {
      font-family: "Montserrat-Medium", sans-serif;
      font-size: 0.9rem;
      padding: 0.2rem 1rem;
      border-radius: 0.2rem;
      cursor: pointer;
      background: transparent;
      transition: 0.2s;
    }

    .btn-editar {
      color: #005516;
      border: #005516 solid 0.15rem;
    }

    .btn-editar:hover {
      color: white;
      background-color: #005516;
    }

    .btn-excluir {
      color: #d32f2f;
      border: #d32f2f solid 0.15rem;
    }

    .btn-excluir:hover {
      color: white;
      background-color: #d32f2f;
    }
  }
}

/* Ajuste das Abas (Como as ações subiram, as abas agora ocupam 100% da largura do container de abas) */
.container-abas-topo {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  background: transparent !important;
  background-color: transparent !important;
  border-bottom: 1px solid #d7e0d9 !important; 
  margin: 0 0 1.15rem 0;
  padding: 0 0.15rem;

  .abas {
    border-bottom: none;
    margin: 0;
    padding: 0;
  }
}


/*  LARGURA EM TELAS MENORES */
@media screen and (max-width: 1065px) {
  .form.centro,
  .centro {
    width: 90vw !important;
    max-width: 90vw !important;
  }
}

/* ESTILOS DAS ABAS E CONTAINER TOPO  */
.abas {
  display: flex;
  gap: 0.15rem;
  margin: 0 0 1.15rem 0;
  border-bottom: 1px solid #d7e0d9;
  padding: 0 0.15rem;

  .aba {
    border: none;
    background: transparent;
    color: #3d5c45;
    font-family: "Montserrat-Medium", sans-serif;
    font-size: 1.05rem;
    padding: 0.55rem 1.1rem 0.65rem;
    cursor: pointer;
    border-bottom: 0.2rem solid transparent;
    margin-bottom: -1px;
    transition: color 0.15s ease, border-color 0.15s ease;
  }

  .aba:hover { color: #005516; }
  .aba.ativa {
    color: #005516;
    border-bottom-color: #ffa600;
    font-family: "Montserrat-Bold", sans-serif;
  }
}

.conteudo-abas { min-height: 8rem; }

.container-abas-topo {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: 1px solid #d7e0d9;
  margin: 0 0 1.15rem 0;
  padding: 0 0.15rem;

  .abas {
    border-bottom: none;
    margin: 0;
    padding: 0;
  }

  .acoes-topo {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 0.4rem;

    .btn-acao {
      font-family: "Montserrat-Medium", sans-serif;
      font-size: 0.9rem;
      padding: 0.3rem 2rem;
      border-radius: 0.2rem;
      border: none; 
      cursor: pointer;
      background: transparent;
      transition: 0.2s;
    }

    .btn-editar {
      color: #005516;
      border: #005516 solid 0.15rem;
    }
    .btn-editar:hover {
      color: white;
      background-color: #005516;
    }
    
    .btn-excluir {
      color: #d32f2f;
      border: #d32f2f solid 0.15rem;
    }
    .btn-excluir:hover {
      color: white;
      background-color: #d32f2f;
    }
  }
}

/*  ESTILOS DA TABELA DO SEI */
.link-sei-tabela {
  color: #005516;
  font-weight: bold;
  text-decoration: none;
  font-size: 1rem;

  &:hover {
    text-decoration: underline;
  }

  small {
    font-weight: normal;
    color: #888;
  }
}

.alerta-sei {
  margin-top: 1rem;
  padding: 1rem;
  border-radius: 0.5rem;
  font-family: "Montserrat-Medium";
}

.alerta-info {
  color: #005516;
  background-color: #e6f2e8;
}

.alerta-erro {
  color: #721c24;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
}

.tabela-andamentos-sei {
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
  border-radius: 0.5rem;
  overflow: hidden;

  th {
    background-color: #005516;
    color: white;
    padding: 1rem;
    text-align: left;
    font-family: "Montserrat-Bold";
    font-size: 0.95rem;
  }

  td {
    padding: 1rem;
    border-bottom: 1px solid #ddd;
    color: #444;
    font-size: 0.95rem;
  }

  tr:last-child td {
    border-bottom: none;
  }

  tr:hover td {
    background-color: #f9f9f9;
  }
}

.texto-centro {
  text-align: center !important;
  color: #888 !important;
  padding: 2rem !important;
}

.paginacao-wrapper {
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
}

::v-deep .pagination-sei {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
  gap: 5px;

  .page-item {
    a {
      position: relative;
      display: block;
      padding: 0.5rem 0.75rem;
      margin-left: -1px;
      line-height: 1.25;
      color: #005516;
      background-color: #fff;
      border: 1px solid #dee2e6;
      cursor: pointer;
      border-radius: 4px;
      text-decoration: none;

      &:hover {
        background-color: #e9ecef;
        border-color: #dee2e6;
      }
    }

    &.active-page a {
      z-index: 1;
      color: #fff;
      background-color: #005516;
      border-color: #005516;
    }

    &.disabled a {
      color: #6c757d;
      pointer-events: none;
      cursor: auto;
      background-color: #fff;
      border-color: #dee2e6;
    }
  }
}

/* SISTEMA DE CARDS (GRID) */
.painel-dados {
  display: grid;
  gap: 0.85rem;
  margin-top: 0rem;
}

.secao-dados {
  background: #fff;
  border: 1px solid #d9e2db;
  border-radius: 0.5rem;
  padding: 0.85rem 1rem 1rem;
  width: 100%;
  box-sizing: border-box;
}

.secao-titulo {
  margin: 0 0 0.75rem 0;
  padding: 0 0 0.4rem 0;
  border-bottom: 1px solid #e2eae4;
  font-family: "Montserrat-Bold", sans-serif;
  font-size: 0.98rem;
  color: #0a4a22;
  letter-spacing: 0.01em;
  text-transform: uppercase;
}

.grade-dados {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 0.85rem 1rem;
}

.item-dado {
  min-width: 0;
  padding: 0.4rem 0.6rem;
  background: #f7f9f7;
  border: 1px solid #e4ebe5;
  border-radius: 0.4rem;
}

.item-rotulo {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin: 0 0 0.15rem 0;
  font-family: "Montserrat-Medium", sans-serif;
  font-size: 0.96rem;
  line-height: 1.2;
  color: #005516;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.item-valor {
  display: block;
  font-family: "Montserrat-Medium", sans-serif;
  font-size: 0.9rem;
  line-height: 1.3;
  color: #1f1f1f;
  word-break: break-word;
  white-space: pre-wrap;
}

/* Modificadores de Colunas */
.item-dado--span2 {
  grid-column: span 2;
}

.item-dado--span3 {
  grid-column: span 3;
}

.item-dado--span4 {
  grid-column: span 4;
}

.item-dado--largo {
  grid-column: 1 / -1;
}

/*  MODAL DE EXCLUSÃO */
.modal-exclusao {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;

  .modal-mask {
    border-radius: 1rem;
    position: relative;
    z-index: 1000;
    width: 60%;
    max-height: 90vh;
    background-color: #f2f2f2;
    display: flex;
    flex-direction: column;
  }

  .modal-container {
    padding: .7rem;
    display: flex;
    flex-direction: column;
    height: 100%;
    font-family: "Montserrat-Medium", sans-serif;

    .modal-header {
      h2 {
        font-size: 1.3rem;
        font-weight: bold;
        text-align: center;
        margin-top: 1rem;
        flex-shrink: 0;
      }
    }

    .modal-body {
      border: 1px solid gray;
      border-radius: 1rem;
      text-align: center;
      margin: 1rem;
      padding-bottom: 1rem;
      overflow-y: auto;
      flex-grow: 1;

      p {
        font-size: 1rem;
        font-weight: bold;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        color: #005516;
      }

      .dados {
        text-align: left;
        margin-left: 1rem;
        padding-right: 1rem;

        .flexbox {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0.5rem 1.5rem;
          margin-bottom: 0.5rem;
        }

        .texto-centralizado {
          font-weight: bold;
          font-size: 0.95rem;
          color: #000;
          word-break: break-word;
        }

        span {
          font-weight: normal;
          font-size: 0.9rem;
          margin-left: 0.3rem;
          color: #333;
        }
      }
    }

    .modal-footer {
      display: flex;
      justify-content: space-evenly;
      margin-bottom: 1rem;
      flex-shrink: 0;

      .btn-confirmar-exclusao {
        border: none;
        border-radius: .5rem;
        width: 30%;
        height: 2.2rem;
        background-color: #005516;
        color: #f2f2f2;
        cursor: pointer;
      }

      .btn-cancelar-exclusao {
        border: none;
        border-radius: .5rem;
        width: 30%;
        height: 2.2rem;
        background-color: #bd0000;
        color: #f2f2f2;
        cursor: pointer;
      }
    }
  }
}

/* RESPONSIVIDADE GERAL */
@media screen and (max-width: 900px) {
  .fora {
    padding: 0.9rem 1rem 1.35rem !important;
  }

  .grade-dados {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .item-dado--span2,
  .item-dado--span3,
  .item-dado--span4 {
    grid-column: auto;
  }

  .container-abas-topo {
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    border-bottom: none;

    .acoes-topo {
      margin-bottom: 1rem;
    }
  }

  .modal-exclusao {
    .modal-mask {
      width: 85%;
    }
  }
}

@media screen and (max-width: 700px) {
  .fora {
    padding: 0.85rem 1rem 1.25rem !important;
  }

  .topo-header {
    h1 {
      font-size: 1.35rem;
      margin-left: 0.5rem;
    }
  }

  .grade-dados {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 600px) {
  .modal-exclusao {
    .modal-mask {
      width: 95%;
    }

    .modal-container {
      .modal-body {
        .dados {
          .flexbox {
            grid-template-columns: 1fr;
            gap: 0.3rem;
          }
        }
      }
    }
  }
}

</style>